import { useRef } from "react"
import KinescopePlayer from "@kinescope/react-kinescope-player"

import { parseKinescopeLink } from "utils/parseKinescopeLink"
import { isBrowser } from "utils/infrastructure/ssg-utils"

interface Props {
    video: string
    width?: number | string
    height?: number | string
    className?: string
    onPlay?: () => void
}

export function KinescopeVideoPlayer(props: Props) {
    const ref = useRef<KinescopePlayer>(null)
    const link = parseKinescopeLink(props.video)

    if (!(link && isBrowser())) {
        return null
    }

    return (
        <div
            style={{
                backgroundColor: "black",
                borderRadius: "8px",
                overflow: "hidden",
                width: props.width || "100%",
                height: props.height || "100%",
            }}
        >
            <KinescopePlayer
                ref={ref}
                videoId={link?.id}
                onPlay={props.onPlay}
                height={props.height}
            />
        </div>
    )
}
